export default "/images/vendor/flag-icon-css/flags/4x3/vc.svg?a1a39ca12f5354105b9b63fbd6c231de";